export const SET_EMPLOYER_TABLE = "SET_EMPLOYER_TABLE"
export const SET_EMPLOYEE_TABLE = "SET_EMPLOYEE_TABLE"
export const SET_RECIPIENT_TABLE = "SET_RECIPIENT_TABLE"

export const OPEN_EDIT_EMPLOYER = "OPEN_EDIT_EMPLOYER"
export const CLOSE_EDIT_EMPLOYER = "CLOSE_EDIT_EMPLOYER"

export const OPEN_EDIT_RECIPIENT = "OPEN_EDIT_RECIPIENT"
export const CLOSE_EDIT_RECIPIENT = "CLOSE_EDIT_RECIPIENT"